import React from 'react';
import styles from './ClinicsAndChains.module.scss'
import ClinicsTable from "../../../components/ClinicsTable/ClinicsTable";
import {$t} from "../../../helpers/translator";

const DistributorClinicsAndChains = () => {

    return (
        <div className={styles.container}>
            <ClinicsTable header={$t('global.clinics.clinicsAndChains')} userType={4}/>
        </div>

    )

}

export default DistributorClinicsAndChains;

